"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption2: function() {
        return _Caption2.Caption2;
    },
    caption2ClassNames: function() {
        return _useCaption2Stylesstyles.caption2ClassNames;
    }
});
const _Caption2 = require("./Caption2");
const _useCaption2Stylesstyles = require("./useCaption2Styles.styles");
